import i18n from "@/i18n";
import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";
import { AxiosError, AxiosResponse } from "axios";
import $http from "../api-datastores/http";
import { CategoryMapType } from "./types/genre";
import { handleError } from "./shared";

const ErrorApi = { message: "API error", name: "" };

/** @remarks selectable genre v2 */
export async function getGenresV2(
  countryName: string = "jp",
  mapType?: string,
): Promise<PortalAdapterApi.ResponseGetPlaceCategoryList> {
  const language = i18n.locale;
  return await $http
    .get(`/v2/genres`, {
      params: {
        language,
        countryName,
        mapType: mapType === "normal" ? undefined : mapType,
      },
    })
    .then((response: AxiosResponse) =>
      response.status === 200
        ? (response.data as PortalAdapterApi.ResponseGetPlaceCategoryList)
        : Promise.reject(ErrorApi),
    )
    .catch((error: AxiosError) => handleError(error));
}

/** @remarks genresは日常タイプ以外のリストにいるか */
export async function getCategoryMapTypesV2(genreNames: string): Promise<CategoryMapType[]> {
  return await $http
    .get(`/v2/category-map-types`, {
      params: {
        genres: genreNames,
      },
    })
    .then((response: AxiosResponse) => (response.status === 200 ? response.data : Promise.reject(ErrorApi)))
    .catch((error: AxiosError) => handleError(error));
}
